module.exports = __webpack_public_path__ + "static/media/stetic.403a3828.svg";